import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/top-50.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-05bfb495"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "artistListDetail"
};
var _hoisted_2 = {
  class: "hot-song"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "left-box"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  })], -1
  /* HOISTED */
  );
});

var _hoisted_4 = {
  class: "right-box"
};
var _hoisted_5 = {
  class: "header"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "hot-title"
  }, "热门50首", -1
  /* HOISTED */
  );
});

var _hoisted_7 = {
  class: "song-list"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "index"
};
var _hoisted_10 = {
  class: "iconfont icon-icon_horn index active"
};
var _hoisted_11 = {
  class: "name"
};
var _hoisted_12 = {
  class: "duration"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "more-title"
  }, "查看全部50首热门歌曲", -1
  /* HOISTED */
  );
});

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-right"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_15 = [_hoisted_13, _hoisted_14];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _directive_minTenIndex = _resolveDirective("minTenIndex");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 热门50首 "), _createElementVNode("div", _hoisted_2, [_createCommentVNode(" 左边内容：图片 "), _hoisted_3, _createCommentVNode(" 右边热门歌曲列表 "), _createElementVNode("div", _hoisted_4, [_createCommentVNode(" 头部标题 "), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("i", {
    class: "iconfont icon-play",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.songAllClick(_ctx.albumList[0].id);
    })
  })]), _createCommentVNode(" 歌曲列表 "), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albumList.slice(0, _ctx.maxLength), function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "songs-item",
      key: item,
      onClick: function onClick($event) {
        return _ctx.itemClick(item.id);
      }
    }, [_createCommentVNode(" 索引 "), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [_createTextVNode(_toDisplayString(index + 1), 1
    /* TEXT */
    )])), [[_directive_minTenIndex], [_vShow, _ctx.currentId != item.id]]), _createCommentVNode(" 播放图标 "), _withDirectives(_createElementVNode("i", _hoisted_10, null, 512
    /* NEED_PATCH */
    ), [[_vShow, _ctx.currentId == item.id]]), _createCommentVNode(" 歌名和描述 "), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(item.name), 1
    /* TEXT */
    ), _withDirectives(_createElementVNode("span", {
      style: {
        "margin-left": "15px"
      }
    }, "(" + _toDisplayString(item.alia[0]) + ")", 513
    /* TEXT, NEED_PATCH */
    ), [[_vShow, item.alia[0]]])]), _createCommentVNode(" 播放时间 "), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$filters.formatTime(item.dt, "mm:ss")), 1
    /* TEXT */
    )], 8
    /* PROPS */
    , _hoisted_8);
  }), 128
  /* KEYED_FRAGMENT */
  ))]), _createCommentVNode(" 显示更多歌曲 "), _withDirectives(_createElementVNode("div", {
    class: "show-more",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    function () {
      return _ctx.hotTitleClick && _ctx.hotTitleClick.apply(_ctx, arguments);
    })
  }, _hoisted_15, 512
  /* NEED_PATCH */
  ), [[_vShow, _ctx.maxLength != 50]])])])]);
}